import { FC, memo } from 'react'
import reactStringReplace from 'react-string-replace'

import * as SC from '../styles'
import { Accordion, Link, Panel, PanelFace, TextBadge } from 'ui/components'
import { Changes } from 'ui/temp'

import { LicensesChangesProps } from './LicensesChangesProps'

export const LicensesChanges: FC<LicensesChangesProps> = memo((props) => {
  const { data, showAll } = props

  const numberOfUpdateChanges = data.showUpdated?.reduce((sum, current) => sum + current.showChanges.length, 0)

  return (
    <Panel
      title="Licenses"
      titleTagAs="h3"
      face={PanelFace.SMALL_PRIMARY}
      isArrowButton={true}
      rounded={true}
      shadowed={true}
      blockOnClickOnTitle={false}
      expanded={showAll}
    >
      {data.showDeactivated && (
        <Accordion
          title="Deactivated"
          expanded={showAll}
          actions={<TextBadge color="default">{data.showDeactivated.length} changes</TextBadge>}
        >
          {data.showDeactivated.map((item, key) => (
            <SC.AccordionTitle key={key}>
              {reactStringReplace(item.title, /%#(.*)#%/g, (match, i) => (
                <Link key={i} to={'/licenses/$licenseId'} params={{ licenseId: item.id.toString() }}>
                  {match}
                </Link>
              ))}
            </SC.AccordionTitle>
          ))}
        </Accordion>
      )}

      {data.showAdded && (
        <Accordion
          title="Added"
          expanded={showAll}
          actions={<TextBadge color="default">{data.showAdded.length} changes</TextBadge>}
        >
          {data.showAdded.map((item, key) => (
            <SC.AccordionTitle key={key}>{item}</SC.AccordionTitle>
          ))}
        </Accordion>
      )}

      {data.showUpdated && (
        <Accordion
          title="Updated"
          expanded={showAll}
          actions={<TextBadge color="default">{numberOfUpdateChanges} changes</TextBadge>}
        >
          <SC.UpdateWrapper>
            {data.showUpdated.map((item, key) => (
              <span key={key}>
                <SC.AccordionTitle>
                  {reactStringReplace(item.title, /%#(.*)#%/g, (match, i) => (
                    <Link key={i} to={'/licenses/$licenseId'} params={{ licenseId: item.id.toString() }}>
                      {match}
                    </Link>
                  ))}
                  :
                </SC.AccordionTitle>
                <SC.LongText>
                  {item.showChanges.map((el, key) => (
                    <Changes data={el} key={key} />
                  ))}
                </SC.LongText>
              </span>
            ))}
          </SC.UpdateWrapper>
        </Accordion>
      )}
    </Panel>
  )
})
